var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BConversion',{attrs:{"left-label1":"大写字符串","left-label2":"HELLO-WORLD","right-label1":"小写字符串","right-label2":"hello-world","left-button":"大写转小写","right-button":"小写转大写","forward-fn":_vm.toLower,"reverse-fn":_vm.toUpper}})}
var staticRenderFns = []

export { render, staticRenderFns }